import { useTranslation } from "react-i18next";
import AffiliateImage1 from "../../assets/images/affiliate-1.svg";
import AffiliateImage2 from "../../assets/images/affiliate-2.svg";
import AffiliateImage3 from "../../assets/images/affiliate-3.svg";
import AffiliateImage4 from "../../assets/images/affiliate-4.svg";
import ResellerImage1 from "../../assets/images/reseller-1.svg";
import ResellerImage2 from "../../assets/images/reseller-2.svg";
import ResellerImage3 from "../../assets/images/reseller-3.svg";
import ResellerImage4 from "../../assets/images/reseller-4.svg";
import WhiteLabelImage1 from "../../assets/images/white-label-1.svg";
import WhiteLabelImage2 from "../../assets/images/white-label-2.svg";
import WhiteLabelImage3 from "../../assets/images/white-label-3.svg";
import Footer from "../connected/Footer";
import Navbar from "../connected/Navbar";
import PageHeader from "../primitive/PageHeader";
import Hero from "../sections/partnershipSection/Hero";
import ReuseablePartnershipSection from "../sections/partnershipSection/ReuseablePartnershipSection";

const Partnership = () => {
  const { t } = useTranslation("partnership");

  return (
    <>
      <PageHeader browserTitle="Partnership | Smartcomply Seequre" />

      <Navbar />

      <Hero />

      <ReuseablePartnershipSection
        preTitle={t("sections.affiliate.preTitle")}
        title={t("sections.affiliate.title")}
        description={t("sections.affiliate.description")}
        cta={{
          text: t("sections.affiliate.cta"),
          link: "https://partner.smartcomply.com/register",
          target: "_blank",
        }}
        steps={new Array(4).fill().map((_, index) => ({
          image: [
            AffiliateImage1,
            AffiliateImage2,
            AffiliateImage3,
            AffiliateImage4,
          ][index],
          title: t(`sections.affiliate.steps.${index}.title`),
          description: t(`sections.affiliate.steps.${index}.description`),
        }))}
        colors={{
          backgroundColor: "#F3F5FB",
          preTitleBackgroundColor: "#FFFBF5",
        }}
      />

      <ReuseablePartnershipSection
        preTitle={t("sections.reseller.preTitle")}
        title={t("sections.reseller.title")}
        description={t("sections.reseller.description")}
        cta={{
          text: t("sections.reseller.cta"),
          link: "https://partner.smartcomply.com/register",
          target: "_blank",
        }}
        steps={new Array(4).fill().map((_, index) => ({
          image: [
            ResellerImage1,
            ResellerImage2,
            ResellerImage3,
            ResellerImage4,
          ][index],
          title: t(`sections.reseller.steps.${index}.title`),
          description: t(`sections.reseller.steps.${index}.description`),
        }))}
        colors={{
          backgroundColor: "#FFF9F0",
          preTitleBackgroundColor: "#FFFBF5",
        }}
      />

      <ReuseablePartnershipSection
        preTitle={t("sections.whiteLabel.preTitle")}
        title={t("sections.whiteLabel.title")}
        description={t("sections.whiteLabel.description")}
        cta={{
          text: t("sections.whiteLabel.cta"),
          link: "https://partner.smartcomply.com/register",
          target: "_blank",
        }}
        steps={new Array(3).fill().map((_, index) => ({
          image: [WhiteLabelImage1, WhiteLabelImage2, WhiteLabelImage3][index],
          title: t(`sections.whiteLabel.steps.${index}.title`),
          description: t(`sections.whiteLabel.steps.${index}.description`),
        }))}
        colors={{
          backgroundColor: "#FCFFF5",
          preTitleBackgroundColor: "#FFFBF5",
        }}
      />

      <Footer />
    </>
  );
};

export default Partnership;
